import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { postTransactionAuthorizationRequest } from '@src/api'
import { DefaultApiSendTransactionAuthorizationRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useTransactionAuthorizationRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    unknown,
    AxiosResponse<CustomError>,
    DefaultApiSendTransactionAuthorizationRequestRequest
  >({
    mutationFn: (
      params: DefaultApiSendTransactionAuthorizationRequestRequest
    ) => postTransactionAuthorizationRequest(axiosInstance, params),
  })
}
